/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack, TextField } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import AdType from './fields/AdType';
import Api from './fields/Api';
import Associated from './fields/Associated';
import Category from './fields/Category';
import CustomSchedule from './fields/CustomSchedule';
import Name from './fields/Name';
import Size from './fields/Size';
import ThirdPartyTagIds from './fields/ThirdPartyTagIds';
import Variables from './fields/Variables';
import AdParameters from './fields/videoAd/AdParameters';
import AdSystem from './fields/videoAd/AdSystem';
import AdTitle from './fields/videoAd/AdTitle';
import RawVideoS3Path from './fields/videoAd/RawVideoS3Path';

interface InlineVideoProps {
  adGroupId?: number;
}

function InlineVideo({ adGroupId }: InlineVideoProps) {
  const { watch } = useFormContext();

  const formatVideoDuration = (seconds) => {
    if (seconds == null) {
      return '00:00';
    }
    const milliseconds = seconds * 1000;

    let returnValue;
    try {
      returnValue = format(new Date(milliseconds), 'mm:ss');
    } catch {
      returnValue = seconds;
    }

    return returnValue;
  };

  // We use the native MUI TextField instead of the Form/TextField
  // because we are want to display the duration as mm:ss seconds.
  // If it is a Form/TextField, the display value in mm:ss will get submitted
  // to the backend and we do not want that. Again, it's only for display.
  const seconds = watch('videoAd.duration');
  const duration = formatVideoDuration(seconds);

  return (
    <Stack spacing={2}>
      <Name />
      {Boolean(adGroupId) && <Associated />}
      <Category />
      <Stack direction="row" spacing={2}>
        <Size readOnly defaultValue="Video Ad" />
        <AdType />
        <Api />
      </Stack>
      <AdTitle />
      <RawVideoS3Path />
      <TextField label="Video Duration (MM:SS)" inputProps={{ readOnly: true }} value={duration} />
      <AdParameters />
      <AdSystem readOnly />
      <ThirdPartyTagIds />
      <CustomSchedule />
      <Variables />
    </Stack>
  );
}
export default InlineVideo;
